import { h } from 'preact'
import { useState } from 'preact/hooks'
import Modal from '../../../_common/components/Modal/index'
import { ButtonPrimary } from '../../../_common/components/buttons/buttons'
import { isMobileAgent } from '../../../_common/common'
import { useSelector } from 'react-redux'
import {
  getTopics,
  STEP_INFO,
  STEP_SCHEDULE,
  STEP_SELECT_TOPIC,
  TITLE
} from '../ModalHelp/constants.jsx'
import StepInfo from '../ModalHelp/StepInfo'
import StepSelectTopic from '../ModalHelp/StepSelectTopic'
import StepSchedule from '../ModalHelp/StepSchedule'
import { ZohoForm } from '../../../utils/ZohoForm'
import './modal-help-contact-styles.scss'

const VIEW_MAIN = 'main'
const VIEW_RESERVAR = 'reservar'
const VIEW_MENSAJE = 'mensaje'

export default function ModalHelpContact ({ visible, onClose }) {
  const [view, setView] = useState(VIEW_MAIN)
  const { has_fct, has_convas, formative_zone } = useSelector(state => state.status.student_meta)
  const auth = useSelector(state => state.auth)
  const [step, setStep] = useState(isMobileAgent() ? STEP_INFO : STEP_SELECT_TOPIC)
  const [schedule, setSchedule] = useState()

  const handleClose = () => {
    setView(VIEW_MAIN)
    setStep(isMobileAgent() ? STEP_INFO : STEP_SELECT_TOPIC)
    setSchedule(undefined)
    onClose()
  }

  const handleBack = () => {
    setView(VIEW_MAIN)
    setStep(isMobileAgent() ? STEP_INFO : STEP_SELECT_TOPIC)
    setSchedule(undefined)
  }

  const handleSelectTopic = (val) => {
    const topicSelected = getTopics(has_fct, has_convas).find(option => option.key === parseInt(val.topic))
    setSchedule(topicSelected.type)
    setStep(STEP_SCHEDULE)
  }

  const getTitle = () => {
    if (view === VIEW_RESERVAR) return TITLE[step]
    if (view === VIEW_MENSAJE) return 'Enviar un mensaje'
    return 'Ayuda y contacto'
  }

  const firstName = auth?.loggedUser?.name?.trim() || ''
  const lastName = `${auth?.loggedUser?.first_name?.trim() || ''} ${auth?.loggedUser?.last_name?.trim() || ''}`.trim()
  const email = auth?.loggedUser?.email || ''

  return (
    <Modal visible={visible} closeModal={handleClose}>
      <div className='p-all font-color-black'>
        <div className='d-flex flex-space-between'>
          <div className='d-flex flex-center-y gap-1'>
            {view !== VIEW_MAIN && (
              <div className='cursor-pointer' onClick={handleBack}>
                <i className='fal fa-arrow-left font-20' />
              </div>
            )}
            <div className='font-30 font-bold'>{getTitle()}</div>
          </div>
          <div className='icon cursor-pointer' onClick={handleClose}>
            <i className='fal fa-times' />
          </div>
        </div>

        {view === VIEW_MAIN && (
          <div className='modal-help-contact'>
            <p className='modal-help-contact__description'>
              Estamos a tu disposición para ayudarte a resolver cualquier duda o problema.
            </p>
            <div className='modal-help-contact__columns'>
              <div className='modal-help-contact__card'>
                <h3>Reservar cita</h3>
                <p>Selecciona un día y una hora para llamarte y resolver todas tus dudas.</p>
                <ButtonPrimary onClick={() => setView(VIEW_RESERVAR)}>Reservar Cita</ButtonPrimary>
              </div>
              <div className='modal-help-contact__card'>
                <h3>Enviar un mensaje</h3>
                <p>Puedes escribirnos un mensaje explicándonos tu problema y te responderemos en la mayor brevedad posible.</p>
                <ButtonPrimary onClick={() => setView(VIEW_MENSAJE)}>Enviar Mensaje</ButtonPrimary>
              </div>
            </div>
          </div>
        )}

        {view === VIEW_RESERVAR && (
          <div>
            {step === STEP_INFO && <StepInfo onSubmit={() => setStep(STEP_SELECT_TOPIC)} formative_zone={formative_zone} />}
            {step === STEP_SELECT_TOPIC && <StepSelectTopic onSubmit={handleSelectTopic} />}
            {step === STEP_SCHEDULE && <StepSchedule schedule={schedule} />}
          </div>
        )}

        {view === VIEW_MENSAJE && (
          <div className='modal-help-contact__zoho-container'>
            <ZohoForm
              firstName={firstName !== '' ? firstName : `Alumno ${email}`}
              lastName={lastName !== '' ? lastName : `Alumno ${email}`}
              email={email}
            />
          </div>
        )}
      </div>
    </Modal>
  )
}
